import React from 'react'
import { Box, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import SearchBar from '../Search/SearchBar'
import DropDown, { DropDownVariant } from '../Menus/DropDown'
import {
  FetchUserScreeningsScreeningTypeEnum,
  FetchUserScreeningsStatusEnum,
} from '../../swagger'

const UserScreeningTableSearchAndFilters: React.FC<{
  triggerFetch: () => void
  handleFilterChange: (params: {
    filterValue?:
      | string
      | FetchUserScreeningsScreeningTypeEnum
      | FetchUserScreeningsStatusEnum
    filterField: string
  }) => void
  searchValue: string
}> = ({ triggerFetch, handleFilterChange, searchValue }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Box
      mr={2}
      sx={{
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column',
          alignItems: 'center',
          marginLeft: theme.spacing(1.5),
        },
        gap: theme.spacing(0.4),
      }}
    >
      <SearchBar
        handleSearch={(value) => {
          handleFilterChange({ filterValue: value, filterField: 'searchValue' })
          triggerFetch()
        }}
        searchValue={searchValue}
        placeholder={t(
          'UserScreeningTableSearchAndFilters.Search.PlaceHolder',
          'Search'
        )}
        sx={{ '& .MuiOutlinedInput-root': { marginBottom: 0 } }}
      />

      <DropDown
        formControlProps={{
          [theme.breakpoints.down('sm')]: {
            width: '100%',
            margin: theme.spacing(2),
          },
        }}
        id="sort"
        menuOptions={[
          'All Screening Types',
          ...Object.values(FetchUserScreeningsScreeningTypeEnum),
        ].map((option) => {
          return {
            name: option,
            id: option,
          }
        })}
        defaultValue={t(
          'UserScreeningTableSearchAndFilters.ScreenType.SortOption.sort',
          'All Screening Types'
        )}
        handleSelection={(selected) => {
          handleFilterChange({
            filterValue: selected,
            filterField: 'screeningType',
          })
          triggerFetch()
        }}
        variant={DropDownVariant.SortAndFilter}
      />

      <DropDown
        formControlProps={{
          [theme.breakpoints.down('sm')]: {
            width: '100%',
            margin: theme.spacing(2),
          },
        }}
        id="sort"
        menuOptions={[
          'All Statuses',
          ...Object.values(FetchUserScreeningsStatusEnum),
        ].map((option) => {
          return {
            name: option,
            id: option,
          }
        })}
        defaultValue={t(
          'UserScreeningTableSearchAndFilters.Status.SortOption.Sort',
          'All Statuses'
        )}
        handleSelection={(selected) => {
          handleFilterChange({
            filterValue: selected,
            filterField: 'screeningStatus',
          })
          triggerFetch()
        }}
        variant={DropDownVariant.SortAndFilter}
      />
    </Box>
  )
}

export default UserScreeningTableSearchAndFilters
